/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2026 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'
import classnames from 'classnames';

import { AppContext } from '../AppContext'
import BroadcastEmail from './BroadcastEmail'
import GmailConfig from './GmailConfig'

class EmailControlPanel extends React.Component
{  
  activeTabLS = 'emailControlPanel.activeTab';

  componentDidMount()
  {
    var activeTab = Number(this.context.appLocalStorage.getItem(this.activeTabLS));
    if (null === activeTab) activeTab = 0;
    this.setState({tabIndex: activeTab});
    document.title = this.context.websiteProfile.profileName + ': Email Admin'
  }
  
  constructor(props)
  {
    super();


    this.state =
    {
      tabIndex: 0
    };
  }

  render()
  {
    return(
      <AppContext.Consumer>
      {({ websiteProfile, fetchWebsiteProfile }) => (
        <div>
          <Nav tabs>
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 0 })}
              onClick={() => { this.toggleTab(0); }}
            >
                Config
              </NavLink>
            </NavItem>
          {( 'Y' === websiteProfile.smtpEnabled && 
            <NavItem>
              <NavLink className={classnames({ active: this.state.tabIndex === 1 })}
                onClick={() => { this.toggleTab(1); }}
              >
                Broadcast
              </NavLink>
            </NavItem>
          )}
          </Nav>
          <TabContent activeTab={this.state.tabIndex}>
            <TabPane tabId={0}>
              <GmailConfig tabId={0} tabIndex={this.state.tabIndex} smtpEnabled={websiteProfile.smtpEnabled}
                fetchWebsiteProfile={fetchWebsiteProfile} checkEnableStatus={this.props.checkEnableStatus}/>
            </TabPane>
          {( 'Y' === websiteProfile.smtpEnabled && 
            <TabPane tabId={1}>
              <BroadcastEmail tabId={1} tabIndex={this.state.tabIndex} />
            </TabPane>
          )}
          </TabContent>
        </div>
      )}
      </AppContext.Consumer>
    );
  }

  toggleTab(tabIndex, tab)
  {
    if (this.state.tabIndex !== tabIndex)
    {
      this.setState({ tabIndex: tabIndex });
      this.context.appLocalStorage.setItem(this.activeTabLS, tabIndex);
    } 
  }
}

EmailControlPanel.contextType = AppContext;

export default EmailControlPanel;